import { render, staticRenderFns } from "./Set.vue?vue&type=template&id=23244afc&scoped=true&"
import script from "./Set.vue?vue&type=script&lang=js&"
export * from "./Set.vue?vue&type=script&lang=js&"
import style0 from "./Set.vue?vue&type=style&index=0&id=23244afc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23244afc",
  null
  
)

export default component.exports